import * as core from '../../../../../../../core'
import * as stakeholderAnalysis from '../stakeholder-analysis'

export const RESOURCE = {
  payload: {
    alias: 'stakeholder.log',
    appAlias: stakeholderAnalysis.RESOURCE.payload.alias,
    description: 'View the log of stakeholders for this client',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Stakeholder Log',
    page: { alias: 'stakeholder.log' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
